import React from "react";

export const ExerciseFreeFormId = "b98a090a-cfe5-11e7-8431-a3ea0bef72c5";
export const AccountDemo        = "78a8be61-67f3-11ea-9a8b-6f5ccc6a3bdb";



// WEBPACK FOOTER //
// ./src/utils/StaticIds.js